import { DeclarationForm } from '../components/DeclarationForm/DeclarationForm';

// Inbounds ▸ Incoming Declarations ▸ Edit — see DeclarationForm for the shared UI.
export const EditDeclarationPage = () => <DeclarationForm mode="edit" />;
